"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UuidPgHandler", {
    enumerable: true,
    get: function() {
        return UuidPgHandler;
    }
});
const _genericpg = require("~/db/field-handler/handlers/generic.pg");
const _handlerUtils = require("~/db/field-handler/utils/handlerUtils");
let UuidPgHandler = class UuidPgHandler extends _genericpg.GenericPgFieldHandler {
    async filterEq(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                    qb.where((nestedQb)=>{
                        nestedQb.whereNull(sourceField);
                    });
                } else {
                    qb.where(knex.raw('??::text = ?', [
                        sourceField,
                        val
                    ]));
                }
            }
        };
    }
    async filterNeq(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                    qb.where((nestedQb)=>{
                        nestedQb.where(knex.raw("??::text != ''", [
                            sourceField
                        ])).whereNotNull(sourceField);
                    });
                } else {
                    qb.where((nestedQb)=>{
                        nestedQb.where(knex.raw('??::text != ?', [
                            sourceField,
                            val
                        ])).orWhereNull(sourceField);
                    });
                }
            }
        };
    }
    async filterBlank(args, rootArgs, _options) {
        const { sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    nestedQb.whereNull(sourceField).orWhere(knex.raw("??::text = ''", [
                        sourceField
                    ]));
                });
            }
        };
    }
    async filterNotblank(args, rootArgs, _options) {
        const { sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    nestedQb.whereNotNull(sourceField).where(knex.raw("??::text != ''", [
                        sourceField
                    ]));
                });
            }
        };
    }
    async filterGt(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where(knex.raw('??::text > ?', [
                    sourceField,
                    val
                ]));
            }
        };
    }
    async filterGte(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where(knex.raw('??::text >= ?', [
                    sourceField,
                    val
                ]));
            }
        };
    }
    async filterLt(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where(knex.raw('??::text < ?', [
                    sourceField,
                    val
                ]));
            }
        };
    }
    async filterLte(args, rootArgs, _options) {
        const { val, sourceField } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where(knex.raw('??::text <= ?', [
                    sourceField,
                    val
                ]));
            }
        };
    }
    // Override parent filterNlike: the GenericPgFieldHandler version has an `orWhere(col != '')`
    // clause that is always true for non-empty UUID values, causing no rows to ever be filtered.
    // Fix: use a grouped WHERE so the OR only applies to NULL/empty rows, not all non-empty rows.
    async filterNlike(args, rootArgs, _options) {
        const { sourceField } = args;
        let { val } = args;
        const { knex } = rootArgs;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                    // val is empty -> return all non-empty values and NULLs
                    qb.where((nestedQb)=>{
                        nestedQb.whereNot(knex.raw(`??::text = ''`, [
                            sourceField
                        ])).orWhereNull(sourceField);
                    });
                } else {
                    val = val.startsWith('%') || val.endsWith('%') ? val : `%${val}%`;
                    // "not like" should return rows that don't match, plus NULL rows
                    qb.where((nestedQb)=>{
                        nestedQb.whereNot(knex.raw(`??::text ilike ?`, [
                            sourceField,
                            val
                        ])).orWhereNull(sourceField);
                    });
                }
            }
        };
    }
    async filterIn(args, rootArgs, _options) {
        var _val_split;
        const { val, sourceField } = args;
        const { knex } = rootArgs;
        const values = Array.isArray(val) ? val : val == null ? void 0 : (_val_split = val.split) == null ? void 0 : _val_split.call(val, ',');
        return {
            rootApply: undefined,
            clause: (qb)=>{
                // Build placeholders for each value
                const placeholders = values.map(()=>'?').join(', ');
                qb.where(knex.raw(`??::text IN (${placeholders})`, [
                    sourceField,
                    ...values
                ]));
            }
        };
    }
};
